import '../css/application_tailwind.css'
import '../css/footer.css'
import '@fortawesome/fontawesome-free/css/all';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import * as ActiveStorage from '@rails/activestorage';
import i18n from './i18n_js/index'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import '../css/vue-treeselect.scss'

global.i18n = i18n;

require("turbolinks").start();
require('@rails/activestorage').start();

ActiveStorage.start();

document.addEventListener("turbolinks:load", function() {
  const local = localStorage.getItem('locale');
  global.i18n.locale = local || document.body.dataset.lang;
});

window.referralCode = null;
